import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAppToast from '@/hooks/useAppToast';
import { createInformation, InformationCreatePayload } from '@/services/admin/informations';
import { getApiErrorMessage } from '@/utils/apiError';

export const useAdminInformationCreate = () => {
  const queryClient = useQueryClient();
  const toast = useAppToast();

  return useMutation({
    mutationFn: ({ siteType, data }: { siteType: string; data: InformationCreatePayload }) =>
      createInformation(siteType, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['informations', variables.siteType],
      });
      toast.success('更新しました。');
    },
    onError: error => {
      const msg = getApiErrorMessage(error, 'エラーが発生しました。');
      toast.error(msg);
    },
  });
};
